module.exports = __webpack_public_path__ + "loginIMG_new.png?dab7423e24eb8d43b33c0429cf4c18ce";